import apiClient from './index';
import {
  ReportScheduleCreate,
  ReportScheduleRead,
  ReportScheduleUpdate,
} from './types';

export const reportSchedulesApi = {
  async list(residentialComplexId: string): Promise<ReportScheduleRead[]> {
    const res = await apiClient.get<ReportScheduleRead[]>('/report-schedules/', {
      params: { residential_complex_id: residentialComplexId },
    });
    return res.data;
  },
  async create(payload: ReportScheduleCreate): Promise<ReportScheduleRead> {
    const res = await apiClient.post<ReportScheduleRead>('/report-schedules/', payload);
    return res.data;
  },
  async update(id: string, payload: ReportScheduleUpdate): Promise<ReportScheduleRead> {
    const res = await apiClient.put<ReportScheduleRead>(`/report-schedules/${id}`, payload);
    return res.data;
  },
  async remove(id: string): Promise<void> {
    await apiClient.delete(`/report-schedules/${id}`);
  },
  async test(id: string): Promise<void> {
    await apiClient.post(`/report-schedules/${id}/test`);
  },
};
